import React from 'react';
import { Avatar, Tag, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { separateOwners, formatOwnerName, getOwnerAvatarUrl } from './ownerUtils';
import './PostHeader.css';

const PostHeader = ({ post, isDarkMode }) => {
  const { humanOwners, agentOwners } = separateOwners(post.owners || []);
  const primaryHuman = humanOwners[0];

  // Create tooltip content for agents
  const renderAgentTooltipContent = () => (
    <div className="agent-tooltip-content">
      <div className="tooltip-header">AI Agents</div>
      <div className="agents-list">
        {agentOwners.map((agent, index) => (
          <div key={index} className="agent-row">
            <Avatar
              size={20}
              src={getOwnerAvatarUrl(agent)}
              icon={<UserOutlined />}
              className="agent-tooltip-avatar"
            />
            <span className="agent-tooltip-name">
              {formatOwnerName(agent)}
            </span>
            <Tag size="small" color="blue" className="agent-tag">
              Agent
            </Tag>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={`post-header ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="post-owners-stack">
        {/* Primary human owner */}
        {primaryHuman && (
          <div className="primary-owner">
            <Avatar
              size={40}
              src={getOwnerAvatarUrl(primaryHuman)}
              icon={<UserOutlined />}
              className="human-avatar"
            />
            <div className="owner-details">
              <span className="owner-name">
                {formatOwnerName(primaryHuman)}
              </span>
            </div>
          </div>
        )}

        {/* Stacked agents with Ant Design Tooltip */}
        {agentOwners.length > 0 && (
          <Tooltip
            title={renderAgentTooltipContent()}
            placement="bottomLeft"
            trigger={['hover', 'click']}
            overlayClassName={`agent-tooltip-overlay ${isDarkMode ? 'dark' : 'light'}`}
            mouseEnterDelay={0.3}
            mouseLeaveDelay={0.1}
          >
            <div className="agent-stack">
              <div className="agent-avatars">
                {agentOwners.slice(0, 3).map((agent, index) => (
                  <Avatar
                    key={index}
                    size={32}
                    src={getOwnerAvatarUrl(agent)}
                    icon={<UserOutlined />}
                    className="stacked-avatar"
                    style={{
                      marginLeft: index > 0 ? '-8px' : '0',
                      zIndex: 10 - index,
                    }}
                  />
                ))}
                {agentOwners.length > 3 && (
                  <div className="more-agents">
                    +{agentOwners.length - 3}
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        )}


      </div>
    </div>
  );
};

export default PostHeader;
